export function getPaginationPages(current: number, total: number): (number | '...')[] {
  current = Math.max(1, Math.min(current, total))
  if (total <= 10) {
    return Array.from({ length: total }, (_, i) => i + 1)
  }
  const pages = []
  pages.push(1)
  if (current > 4) pages.push('...')
  for (let i = Math.max(2, current - 2); i <= Math.min(total - 1, current + 2); i++) {
    if (i !== 1 && i !== total) {
      pages.push(i)
    }
  }
  if (current < total - 3) pages.push('...')
  pages.push(total)
  return pages
}

export function getTotalPages(totalItems: number, pageSize: number): number {
  return Math.ceil(totalItems / pageSize)
}

export function paginate<T>(items: T[], page: number, pageSize: number): T[] {
  const start = (page - 1) * pageSize
  return items.slice(start, start + pageSize)
}
